import React, { createContext, useContext, useRef, useState } from 'react'

interface ITabsContextProps {
  tabSelected: string
  tabListRef: React.MutableRefObject<HTMLDivElement | null>
  changeTabSelected: (newTab: string) => void
}

export interface TabsProviderProps {
  children: React.ReactNode
  initialSelectedTab?: number
}

const TabsContext = createContext<ITabsContextProps>({} as ITabsContextProps)

const TabsProvider = ({ children, initialSelectedTab }: TabsProviderProps): JSX.Element => {
  const [tabSelected, setTabSelected] = useState(initialSelectedTab ? `tab-${initialSelectedTab}` : 'tab-0')
  const tabListRef = useRef<HTMLDivElement>(null)

  const changeTabSelected = (newTab: string): void => {
    setTabSelected(newTab)
  }

  return <TabsContext.Provider value={{ tabSelected, tabListRef, changeTabSelected }}>{children}</TabsContext.Provider>
}

const useTabs = (): ITabsContextProps => {
  const context = useContext(TabsContext)
  const contextIsEmpty = Object.keys(context).length === 0

  if (contextIsEmpty) {
    throw new Error('Error in creating the context -> The children must be wrapped in a <Tabs /> component.')
  }

  return context
}

export { TabsProvider, useTabs }
